// extracted by mini-css-extract-plugin
export default {"characteristics":"characteristicsTable-module--characteristics--9YFt8","characteristics__table":"characteristicsTable-module--characteristics__table--VSy6v"};